import CaicSexRadio from './src/CaicSelSexRadio.vue'
const sexRadio = {
  install: function (Vue) {
    Vue.component(CaicSexRadio.name, CaicSexRadio)
  }
}
export default sexRadio



// WEBPACK FOOTER //
// ./src/sex-radio/index.js